export default __webpack_public_path__ + "static/media/telegramBlack.307c6113.svg";